import { GoClock } from "react-icons/go";
import { Link, useLocation } from "react-router-dom";
import Button from "../../Shared/Button/Button";
import WonAndBoughtOptions from "../ItemsWonAndBought/WonAndBoughtOptions";
import MyBusinessListingOptions from "../MyBusinessListing/MyBusinessListingOptions";
import MyListingOffersOptions from "../MyListingOffers/MyListingOffersOptions";
import MessageOptions from "../MyMessages/MessageOptions";
import WatchListOptions from "../WatchList/WatchListOptions";
import ReviewOptions from "./ReviewOptions";

const Options = ({ biddingTime }) => {
  const location = useLocation();
  const path = location.pathname;

  switch (path) {
    case "/user/won-and-bought":
    case "/user/sold-items":
      return <WonAndBoughtOptions />;
    case "/user/watch-list":
      return <WatchListOptions />;
    case "/user/message":
    case "/user/chat":
      return <MessageOptions />;
    case "/user/listing-offers":
      return <MyListingOffersOptions />;
    case "/user/my-business":
      return <MyBusinessListingOptions />;
    case "/user/reviews-receieved":
    case "/user/reviews-given":
    case "/user/reviews-pending":
      return <ReviewOptions />;

    default:
      return (
        <div className="flex flex-col items-center justify-center border-l border-lightGray p-2.5">
          <p className="mb-2 font-pop text-2xl font-semibold text-blue">
            R299,999.00
          </p>
          {path === "/user/bidding-on" ? (
            <div className="mb-2 flex items-center gap-3">
              <GoClock className=" h-5 w-5 text-redBorder" />
              <span className="font-pop text-base font-medium text-darkGreen">
                2 days ago
              </span>
            </div>
          ) : (
            <Button
              text="Bid Now"
              variant="outline"
              className="mb-3 !w-4/6 !border-blue !pt-2 !pb-2 !text-xs"
            />
          )}
          <p className="mb-3 rounded-[5px] bg-quantityColor py-1 px-3 font-pop text-sm font-semibold text-secondary">
            5 bid(s)
          </p>
          <p className="font-sm mb-2.5 text-center font-pop">
            Remaining Time <br />{" "}
            <span className="text-primary">01 Day 18:44:05</span>
          </p>

          <Link to="/auctionlisting" className="flex w-full justify-center">
            <Button
              text="View Item"
              variant="primary"
              className="pt-2 pb-2 !text-xs"
            />
          </Link>
        </div>
      );
  }
};

export default Options;
